import { batchToExcel } from '@/utils/json2excel'
import html2canvas from "html2canvas"
import jsPDF from 'jspdf'
export default {
    data() {
        return {
            baseUrl: this.$global.baseUrl,
            searchContent: "",
            fullOrgId: null,
            isPass: null,
            examStatus: null,
            examStatusDisabled: false,
            pageIndex: 1,
            pageSize: 12,
            total: 0,
            tableData: [],
            multipleSelection: [],
            tree: null,
            orgTree: [],
            answerDialogShow: false,
            answerTableData: [],
        }
    },
    mounted: function () {
        this.requestTreeData();
        this.query();
    },
    methods: {
        /**
         * 点击事件
         * @param {*} id 
         */
        clickEvent: function (id, data) {
            switch (id) {
                case "search": //搜索
                    this.pageIndex = 1;
                    this.query();
                    break;
                case "exam_resit": //批量作废重考
                    if (this.multipleSelection.length == 0) {
                        this.$message.closeAll();
                        this.$message.warning("请至少选择一项进行操作");
                        return;
                    }
                    var paperIds = [];
                    for (var i = 0; i < this.multipleSelection.length; i++) {
                        paperIds.push(this.multipleSelection[i].id);
                        if (this.multipleSelection[i].score == -1) {
                            this.$message.closeAll();
                            this.$message.warning("考试作废项包含正在考试的数据，无法进行作废操作！");
                            return;
                        }
                    }
                    this.$confirm('此操作将对所选中的考试进行作废操作, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.resitExam(paperIds);
                    }).catch(() => { });
                    break;
                case "resit"://作废重考
                    if (data.score == -1) {
                        this.$message.closeAll();
                        this.$message.warning("当前记录处于正在考试中，无法进行作废操作！");
                        return;
                    }
                    this.$confirm('此操作将对' + data.userName + '的考试进行作废, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.resitExam([data.id])
                    }).catch(() => {
                    });
                    break;
                case "answer_show"://参考答案
                    this.requestAnswer(data.id);
                    this.answerDialogShow = true;
                    break;
                case "export_excel"://导出excel
                    var data = [];
                    Object.assign(data, this.answerTableData);
                    for (var i = 0; i < data.length; i++) {
                        var elem = data[i];
                        elem.index = i + 1;//序号
                        var answer = "";
                        elem.answerList.forEach(item => {
                            answer += item + " / "
                        });
                        elem.answer = answer.substring(0, answer.length - 3);
                    };
                    const th = ['序号', '标题', '试题题型', '参考答案'];
                    const filterVal = ['index', 'title', 'subjectType', 'answer'];
                    data = data.map(v => filterVal.map(k => v[k]));
                    const sheetName = "参考答案";
                    batchToExcel("参考答案", "xlsx", [{ th, data, sheetName }]);
                    break;
                case "export_pdf"://导出PDF
                    html2canvas(document.getElementById("tab-box")).then(canvas => {
                        var contentWidth = canvas.width;
                        var contentHeight = canvas.height;

                        //一页pdf显示html页面生成的canvas高度;
                        var pageHeight = contentWidth / 592.28 * 841.89;
                        //未生成pdf的html页面高度
                        var leftHeight = contentHeight;
                        //页面偏移
                        var position = 0;
                        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
                        var imgWidth = 595.28;
                        var imgHeight = 592.28 / contentWidth * contentHeight;

                        var pageData = canvas.toDataURL('image/jpeg', 1.0);

                        var pdf = new jsPDF('', 'pt', 'a4');

                        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
                        //当内容未超过pdf一页显示的范围，无需分页
                        if (leftHeight < pageHeight) {
                            pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
                        } else {
                            while (leftHeight > 0) {
                                pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                                leftHeight -= pageHeight;
                                position -= 841.89;
                                //避免添加空白页
                                if (leftHeight > 0) {
                                    pdf.addPage();
                                }
                            }
                        }
                        pdf.save('参考答案.pdf');
                    });
                    break;
                case "export_image"://导出图片
                    html2canvas(document.getElementById("tab-box")).then(canvas => {
                        let link = document.createElement("a");
                        link.href = canvas.toDataURL();//下载链接
                        link.setAttribute("download", "参考答案.png");
                        link.style.display = "none";//a标签隐藏
                        document.body.appendChild(link);
                        link.click();
                    });
                    break;
                default:
                    break;
            }
        },

        /**
         * 时间补0
         * @param {*} val 
         */
        formatBit(val) {
            val = +val
            return val > 9 ? val : '0' + val
        },

        /**
         * 秒转时分秒
         * @param {*} time 
         */
        formatSeconds(time) {
            let min = Math.floor(time % 3600)
            let val = this.formatBit(Math.floor(time / 3600)) + '时' + this.formatBit(Math.floor(min / 60)) + '分' + this.formatBit(time % 60) + '秒'
            return val
        },

        /**
         * 格式化日期
         */
        parseDate: function (date) {
            if (date == null || date == "")
                return "";
            return date.substring(0, 10);
        },

        /**
         * 表格选中事件
         * @param {*} val 
         */
        tableColumnCheckEvent: function (val) {
            this.multipleSelection = val;
        },

        /**
         * 翻页操作
         */
        handlePageChange: function (val) {
            this.pageIndex = val;
            this.query();
        },

        /**
         * 机构变更选择
         * @param {*} val 
         */
        postChangeOrgHandleChange: function (val) {
            if (val == null || val.length == 0) {
                this.fullOrgId = null;
                return;
            }
            var fullOrgId = "";
            val.forEach(elem => {
                fullOrgId += elem + "/";
            });
            this.fullOrgId = fullOrgId.length > 0 ? fullOrgId.substring(0, fullOrgId.length - 1) : fullOrgId;
        },

        /**
         * 考试情况状态改变
         * @param {*} val 
         */
        isPassChange: function (val) {
            if (this.isPass == null) {
                this.examStatusDisabled = false;
                return;
            }
            this.examStatus = null;
            this.examStatusDisabled = true;
        },

        /**
         * 情况考试情况状态
         */
        isPassClear: function () {
            this.examStatusDisabled = false;
        },

        /**
         * 递归构造tree数据
         * @param {*} data 
         */
        toTree: function (data) {
            data.forEach(function (item) {
                delete item.children;
            });

            var map = {};
            data.forEach(function (item) {
                map[item.id] = item;
            });
            var val = [];
            data.forEach(function (item) {
                // 以当前遍历项，的parentId,去map对象中找到索引的id
                var parent = map[item.parentId];
                if (parent) {
                    (parent.children || (parent.children = [])).push(item);
                } else {
                    val.push(item);
                }
            });
            return val;
        },

        /**
         * 递归处理tree数据
         * @param {*} data 
         */
        toOrgTree: function (data) {
            data.forEach(item => {
                if (item.children == null || item.children.length == 0) {
                    if (item.orgType != 3) {
                        item.disabled = true;
                    }
                } else {
                    this.toOrgTree(item.children);
                }
            })
        },

        /**
         * 查询左侧树列表
         */
        requestTreeData: function () {
            this.$post({
                url: 'org/queryByPage',
                params: {
                    pageIndex: 1,
                    pageSize: 10000
                }
            }).then(response => {
                //递归解析tree数据
                this.tree = this.toTree(response.data);
                this.orgTree = this.tree;
                this.toOrgTree(this.orgTree);
            });
        },

        /**
         * 作废考试
         */
        resitExam: function (paperIds) {
            if (paperIds == null || paperIds.length == 0) {
                this.$message.warning("未选中所需作废项");
                return;
            }
            this.$post({
                url: "/exam/resitExam",
                params: {
                    ids: paperIds
                }
            }, true).then(res => {
                this.$message.closeAll();
                this.$message.success("操作成功");
                this.query();
            });
        },

        /**
         * 参考答案
         */
        requestAnswer: function (id) {
            this.$post({
                url: "/exam/findExamPaperAnswer",
                params: {
                    id: id
                }
            }, true).then(res => {
                this.answerTableData = res;
            });
        },

        /**
         * 查询
         */
        query: function () {
            this.$post({
                url: 'exam/queryExamPaperRecordByPage',
                params: {
                    keyWord: this.searchContent,
                    fullOrgId: this.fullOrgId,
                    isPass: this.isPass,
                    examStatus: this.examStatus,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                }
            }, true).then(response => {
                this.total = response.total;
                this.tableData = response.data;
            });
        }
    }
}